import { Channel } from '@/generated';

export const MOBILE_EDITOR_ROUTES = {
  PUSH: 'push-editor',
  SMS: 'sms-editor',
  MMS: 'mms-editor',
} as const;

export type MobileChannel = Channel.Push | Channel.Sms | Channel.Mms;

export const CHANNEL_ROUTE_MAP: Record<MobileChannel, string> = {
  [Channel.Push]: MOBILE_EDITOR_ROUTES.PUSH,
  [Channel.Sms]: MOBILE_EDITOR_ROUTES.SMS,
  [Channel.Mms]: MOBILE_EDITOR_ROUTES.MMS,
};

export const getEditorRouteForChannel = (channel: Channel): string =>
  CHANNEL_ROUTE_MAP[channel as MobileChannel] ||
  CHANNEL_ROUTE_MAP[Channel.Push];

export const getChannelFromRoute = (pathname: string): MobileChannel => {
  const entry = (
    Object.entries(CHANNEL_ROUTE_MAP) as [MobileChannel, string][]
  ).find(([_, route]) => route && pathname.includes(route));
  return entry ? entry[0] : Channel.Push;
};
